<template>
	<router-link v-bind:to="href" active-class="active" tag="a" exact>
		<slot></slot>
	</router-link>
</template>

<script>
	import routes from '../routes'
	export default {
		props: {
			href: {
				type: String,
				required: true
			}
		}
	}
</script>

<style scoped>
	a {
		text-decoration: none;
		color: rgba(255, 255, 255, 0.4);
		display: block;
		text-align: center;
		padding: 16px;
		box-shadow: 0 0 0 #FFF;
		transition: all 0.2s ease-in-out;
	}

	a:hover {
		color: rgb(226, 226, 226);
		box-shadow: 0 4px 0 rgb(226, 226, 226);
	}

	.active {
		color: white;
		box-shadow: 0 4px 0 #FFF;
	}
</style>


// WEBPACK FOOTER //
// VLink.vue?06ed1712